import { api } from "./api";
import type { WorkspaceAddonsStateResponse } from "@/types";

/**
 * Workspace add-ons HTTP service — Add-ons panel state read.
 *
 * Source: docs/product/experience-and-ui.md § 8b Members & billing — Add-ons panel
 * (Pro-tier interactive only per L1037); backend handler at
 * `backend/app/api/v1/workspace_addons.py` (GET-only).
 *
 * The former `toggleComplianceAddon` (`PUT /workspace/addons/compliance`
 * wrapper) was REMOVED 2026-07-12 (ENG-TRUE-DEDUP-UX-POLISH compliance
 * dual-path unification): the canonical toggle is
 * `toggleComplianceAddon` in `services/billing.ts` —
 * `POST /api/v1/billing/addons/compliance` — which is payment-backed
 * and syncs the `Workspace.compliance_addon_active` entitlement column
 * server-side.
 *
 * The former `toggleManagedImageAddon` wrapper was REMOVED 2026-07-09
 * (ENG-TRUE-DEDUP-UX-POLISH B4): the Managed Image Add-on card is
 * RETIRED per spec § 8b — managed image is metered on every plan.
 */

/**
 * GET /api/v1/workspace/addons — the persisted Add-ons panel state
 * (`compliance_addon_active` + `region_pin`) the cards seed from.
 * Before this read existed the cards seeded from hardcoded defaults
 * and lied after every reload (ENG-TRUE-DEDUP-UX-POLISH B2).
 */
export async function readWorkspaceAddonsState(): Promise<WorkspaceAddonsStateResponse> {
  const { data } = await api.get<WorkspaceAddonsStateResponse>(
    "/api/v1/workspace/addons",
  );
  return data;
}
